import { useTranslation } from "react-i18next"
import { formatDate } from "@/lib/format-date"

type Props = { completedAt: string | null; isCancelled?: boolean }
const AppointmentClosedStatusIndicator = ({ completedAt, isCancelled }: Props) => {
  const { t } = useTranslation()

  return (
    <div data-testid="appointment-closed-status-indicator" className="truncate">
      {`${isCancelled ? t("scheduling.waitingRoom.grid.cancelledAt") : t("scheduling.waitingRoom.grid.completedAt")} ${
        completedAt ? formatDate(new Date(completedAt), "HH:mm") : ""
      }`}
    </div>
  )
}

export { AppointmentClosedStatusIndicator }
